function getYPos(el) {
    const relativeToViewport = el.getBoundingClientRect().top;
    const viewportRelativeToDocument = window.pageYOffset || document.documentElement.scrollTop;

    return relativeToViewport + viewportRelativeToDocument;
}

function getNavHeight() {
    const nav = document.querySelector('.js_aboutNav--sticky');

    return nav ? nav.offsetHeight : 0;
}

function scrollToSection(sectionId) {
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);

    if (section) {
        const yPos = getYPos(section);
        const navHeight = getNavHeight();

        window.scrollTo({
            top: yPos - navHeight - 30,
            left: 0,
            behavior: 'smooth',
        });
    }
}

function handleClick(button) {
    const sectionId = button.getAttribute('data-nav-button-for-section');
    
    scrollToSection(sectionId);
}

function init() {
    const buttons = [...document.querySelectorAll('[data-nav-button-for-section]')];

    buttons.forEach(button => button.addEventListener('click', e => handleClick(button)));
}

$(document).ready(init);
